import { Flex, Loader, Stack, Text } from "@mantine/core";
import { useSignalDocuments } from "../../../../hooks/QueryHooks";
import SignalDocumentCard from "./SignalDocumentCard";

type Props = {
  workspaceId: string;
  entityId?: string;
  signalRunId?: string;
  automationId?: string;
};

const SignalDocumentsPanel = ({ workspaceId, entityId, signalRunId, automationId }: Props) => {
  const { data: documents, isLoading }: any = useSignalDocuments({
    workspaceId,
    entityId,
    signalRunId,
    automationId,
    enabled: !!workspaceId,
  });

  if (isLoading) {
    return (
      <Flex justify="center" py="xl">
        <Loader size="sm" />
      </Flex>
    );
  }

  if (!documents?.length) {
    return (
      <Flex justify="center" py="xl">
        <Text size="sm" c="dimmed">No AI documents generated yet</Text>
      </Flex>
    );
  }

  return (
    <Stack gap="sm" p="md">
      {documents.map((doc: any) => (
        <SignalDocumentCard
          key={doc.id}
          document={doc}
          workspaceId={workspaceId}
        />
      ))}
    </Stack>
  );
};

export default SignalDocumentsPanel;
